import axios from 'axios';
import { useEffect, useState } from 'react';
import { BiCheck, BiEdit, BiTrash } from 'react-icons/bi';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import SearchBar from '../SearchBar';
import AddMentorForm from './AddMentorForm';
import EditMentorForm from './EditMentorForm';
import './Mentor.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function Mentor() {
  const [mentors, setMentors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const fetchMentors = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/mentor/getMentorsDetailsForAdmin.php`);
      setMentors(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching mentors:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMentors();
  }, []);

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(0);
  };

  const filteredMentors = mentors.filter((mentor) =>
    Object.values(mentor).some(
      (value) =>
        typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const pageCount = Math.ceil(filteredMentors.length / itemsPerPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleAddMentor = () => {
    setShowAddModal(true);
  };

  const handleEditMentor = (mentor) => {
    setSelectedMentor(mentor);
    setShowEditModal(true);
  };

  const handleAddSubmit = async (formData) => {
    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        formDataToSend.append(key, formData[key]);
      });

      const response = await axios.post(`${BASE_URL}/mentor/addMentorDetails.php`, formData);

      const result = response.data;
      if (result.success) {
        alert('Mentor Added Successfully!');
        setShowAddModal(false);
        fetchMentors();
      } else {
        alert(result.error || 'Failed to add mentor. Please try again.');
      }
    } catch (error) {
      console.error('Error adding mentor:', error);
      if (error.response && error.response.data.error) {
        alert(`Error: ${error.response.data.error}`);
      } else {
        alert('Failed to add mentor. Please try again.');
      }
    }
  };

  const handleEditSubmit = async (formData) => {
    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        formDataToSend.append(key, formData[key]);
      });

      const response = await axios.post(`${BASE_URL}/mentor/updateMentorDetails.php`, formData);

      const result = response.data;
      if (result.success) {
        alert('Mentor Updated Successfully!');
        setShowEditModal(false);
        fetchMentors();
      } else {
        alert('Failed to update mentor. Please try again.');
      }
    } catch (error) {
      console.error('Error updating mentor:', error);
      alert('Failed to update mentor. Please try again.');
    }
  };

  const handleApproveMentor = async (mentorId, email, name) => {
    try {
      const response = await axios.put(`${BASE_URL}/mentor/approveMentorDetails.php`, { isApproved: true, email, name, mentorId });

      const result = await response.data;
      if (result.success) {
        alert('Mentor Approved Successfully!');
        fetchMentors();
      } else {
        alert('Failed to approve mentor. Please try again.');
      }
    } catch (error) {
      console.error('Error approving mentor:', error);
      alert('Failed to approve mentor. Please try again.');
    }
  };

  const handleDeleteMentor = async (mentorId) => {
    try {
      const confirmation = window.confirm("Are you sure you want to delete this mentor? This action cannot be undone.");
  
      if (!confirmation) {
        return;
      }
  
      const response = await axios.put(`${BASE_URL}/mentor/deleteMentor.php`, { mentorId });
  
      const result = await response.data;
      if (result.success) {
        alert('Mentor Deleted Successfully!');
        fetchMentors();
      } else {
        alert('Failed to delete mentor. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting mentor:', error);
      alert('Failed to delete mentor. Please try again.');
    }
  };  

  const formatDateToDisplay = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div>
      <h2>Mentors</h2>
      <div className="search-bar">
        <SearchBar onSearch={handleSearch} />
      </div>
      {isLoading ? (
        <p>Loading mentors...</p>
      ) : (
        <div>
          <button className='add-button' onClick={handleAddMentor}>Add Mentor</button>

          {showAddModal && (
            <AddMentorForm
              onSubmit={handleAddSubmit}
              onClose={() => setShowAddModal(false)}
            />
          )}

          {showEditModal && (
            <EditMentorForm
              mentor={selectedMentor}
              onSubmit={handleEditSubmit}
              onClose={() => setShowEditModal(false)}
            />
          )}

          <table>
            <thead>
              <tr>
                <th>Profile Image</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Qualification</th>
                <th>Approval Status</th>
                <th>Registration Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredMentors
                .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
                .map((mentor) => (
                  <tr key={mentor.mentorId}>
                    <td>
                      {/* Displaying the image */}
                      {mentor.profileImageName ? (
                        <img
                          src={`${BASE_URL}/images/profile/${mentor.profileImageName}`}
                          alt={mentor.name}
                          className='profile-image'
                        />
                      ) : (
                        <p>No Image</p>
                      )}
                    </td>
                    <td>{mentor.name}</td>
                    <td>{mentor.email}</td>
                    <td>{mentor.phone}</td>
                    <td>{mentor.qualifications}</td>
                    <td>{mentor.isApproved ? 'Approved' : 'Pending'}</td>
                    <td>{formatDateToDisplay(mentor.createdAt)}</td>
                    <td>
                      <button onClick={() => handleEditMentor(mentor)}>
                        <BiEdit />
                      </button>
                      {!mentor.isApproved && (
                        <button
                          className='approve-button'
                          onClick={() => handleApproveMentor(mentor.mentorId, mentor.email, mentor.name)}
                        >
                          <BiCheck />
                        </button>
                      )}
                      <button onClick={() => handleDeleteMentor(mentor.mentorId)}>
                        <BiTrash />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <ReactPaginate
            previousLabel={<FaChevronLeft />}
            nextLabel={<FaChevronRight />}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageChange}
            containerClassName={'pagination'}
            activeClassName={'active'}
            forcePage={currentPage}
          />
        </div>
      )}
    </div>
  );
}

export default Mentor;
